import React from 'react';
import Icon, { IconContainer } from './Icon';
export function getIconClass(icon, staticDefaultProps) {
  return props => /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    icon: icon
  }, staticDefaultProps));
}
export const getInterface16IconClass = (icon, {
  withContainer
} = {}) => {
  const staticDefaultProps = {
    iconSize: 16,
    backgroundSize: withContainer ? 16 : undefined
  };
  if (withContainer !== undefined) {
    staticDefaultProps.withContainer = withContainer;
  }
  return getIconClass(icon, staticDefaultProps);
};
export const getInterface24IconClass = (icon, {
  withContainer
} = {}) => {
  const staticDefaultProps = {
    iconSize: 24,
    backgroundSize: withContainer ? 24 : undefined
  };
  if (withContainer !== undefined) {
    staticDefaultProps.withContainer = withContainer;
  }
  return getIconClass(icon, staticDefaultProps);
};
export const getPaymentSystemIconClass = icon => {
  const staticDefaultProps = {
    iconSize: 32
  };
  return getIconClass(icon, staticDefaultProps);
};
export const getSubscriptionsClass = icon => {
  const staticDefaultProps = {
    iconSize: 'auto'
  };
  return getIconClass(icon, staticDefaultProps);
};

/* Proprietary Icons */

export function getIconContainer(svgCode, defaults, horizontal = false) {
  return props => {
    const style = {
      width: horizontal ? 'auto' : undefined,
      height: !horizontal ? 'auto' : undefined
    };
    return /*#__PURE__*/React.createElement(IconContainer, Object.assign({}, defaults, props, {
      svgCode: svgCode,
      style: style
    }));
  };
}
export function getSquareIconContainer(svgCode, defaultProps) {
  return props => /*#__PURE__*/React.createElement(IconContainer, Object.assign({}, defaultProps, props, {
    svgCode: svgCode,
    idRegExp: /paint/g
  }));
}
export const getFlagContainer = svgCode => {
  return getSquareIconContainer(svgCode, {
    iconSize: 40
  });
};
export const getIllustrationContainer = svgCode => {
  return getIconContainer(svgCode, {
    iconSize: 220
  });
};
export const getLogoSquareContainer = svgCode => {
  return getSquareIconContainer(svgCode, {
    iconSize: 24
  });
};
export const getLogoContainer = svgCode => {
  return getIconContainer(svgCode, {
    iconSize: 24
  }, true);
};
export const getMediumContainer = svgCode => {
  return getSquareIconContainer(svgCode, {
    iconSize: 24
  });
};
export const getSmallContainer = svgCode => {
  return getSquareIconContainer(svgCode, {
    iconSize: 16
  });
};